import styled from 'styled-components';
import { cardShadow } from '../../../../themes/shadows';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: ${(props) => props.theme.colors.card};
  border-radius: 10px;
  height: inherit;
`;

export const Card = styled.div`
  width: 80%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px;
  border-radius: 10px;
  box-shadow: ${cardShadow};
  animation-name: 'slidein';
  animation-duration: 0.2s;
  border: 1px solid ${(props) => props.theme.colors.disabled};

  @keyframes slidein {
    from {
      width: 0;
      height: 0;
    }

    to {
      width: 80%;
      height: 60px;
    }
  }
`;

export const Label = styled.label`
  font-size: ${(props) => (props.title ? '12px' : '16px')};
  font-weight: ${(props) => (props.value ? 'bold' : 500)};
  color: ${(props) =>
    props.color ? props.color : props.theme.colors.darkerblue};
  margin: 5px 0;

  ${(props) => props.bold && 'font-weight: bold'}
`;

export const Close = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.label};
  width: 20px;
  height: 20px;
  margin: 0 8px;
  cursor: pointer;
  transition: scale;

  :hover {
    transform: scale(1.1);
  }

  ::after {
    content: 'x';
    font-size: 13px;
    line-height: 0px;
  }
`;

export const Column = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const HiddenThumb = styled.div`
  display: none;
`;

